import { Typography } from "@mui/material";

export function FieldGroupHeading({ children }: { children: string }) {
  return (
    <Typography
      variant="caption"
      color="text.secondary"
      sx={{ textTransform: "uppercase", letterSpacing: 0.5, display: "block" }}
    >
      {children}
    </Typography>
  );
}
